import axios from 'axios'
import { salesforceAccountType, salesforceContactType } from 'src/types'

type CrmBundle = {
  account: salesforceAccountType | null
  contact: salesforceContactType | null
}

const cache = new Map<string, CrmBundle>()
const inflight = new Map<string, Promise<CrmBundle>>()

export function cacheQuoteCrm(
  quoteId: string,
  account: salesforceAccountType | null | undefined,
  contact: salesforceContactType | null | undefined,
) {
  cache.set(quoteId, { account: account ?? null, contact: contact ?? null })
}

export function getQuoteCrm(quoteId: string): Promise<CrmBundle> {
  const hit = cache.get(quoteId)
  if (hit) return Promise.resolve(hit)

  let pending = inflight.get(quoteId)
  if (!pending) {
    pending = axios
      .get(`/quote/${quoteId}`)
      .then(res => {
        const bundle: CrmBundle = {
          account: (res.data.crmAccount ?? null) as salesforceAccountType | null,
          contact: (res.data.crmContact ?? null) as salesforceContactType | null,
        }
        cache.set(quoteId, bundle)
        inflight.delete(quoteId)
        return bundle
      })
      .catch(err => {
        inflight.delete(quoteId)
        throw err
      })
    inflight.set(quoteId, pending)
  }
  return pending
}
